<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2z"><a id="page_viii"></a><a id="page_ix"></a><strong>Contents</strong></h2>
<p class="toc"><a href="#/xhtml/introduction#int">Introduction</a></p>
<p class="toc"><a href="#/xhtml/chapter01#ch1">1. Diana’s Dreams</a></p>
<p class="toc"><span href="#/xhtml/chapter02#ch2" title="Link target outside of Sample">2. The Challenge of Change</span></p>
<p class="toc"><span href="#/xhtml/chapter03#ch3" title="Link target outside of Sample">3. Elevate Your Energy With Greater Health</span></p>
<p class="toc"><span href="#/xhtml/chapter04#ch4" title="Link target outside of Sample">4. The Ultimate Key to Ongoing Energy—Your Compelling Why</span></p>
<p class="toc"><span href="#/xhtml/chapter05#ch5" title="Link target outside of Sample">5. Create a Livelihood in Concert With Your Values</span></p>
<p class="toc"><span href="#/xhtml/chapter06#ch6" title="Link target outside of Sample">6. The Relay Paradigm—True Devotion to Your Team</span></p>
<p class="toc"><span href="#/xhtml/chapter07#ch7" title="Link target outside of Sample">7. Opening the Window of Opportunity</span></p>
<p class="toc"><span href="#/xhtml/chapter08#ch8" title="Link target outside of Sample">8. The Spiritual WOO</span></p>
<p class="toc"><span href="#/xhtml/chapter09#ch9" title="Link target outside of Sample">9. Who You Are Makes a Difference</span></p>
<p class="toc1"><span href="#/xhtml/about#abo" title="Link target outside of Sample">About the Author</span></p>
<p class="toc1"><span href="#/xhtml/acknowledgements#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc1"><span href="#/xhtml/appendix#app" title="Link target outside of Sample">Appendix: Abundance Affirmations</span></p>
<p class="toc1"><span href="#/xhtml/additional#add" title="Link target outside of Sample">Additional Resources from Brian Biro</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?5d39a4fc